const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹'
const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩'

export function toEnglishDigits(value) {
  if (value === null || value === undefined) {
    return ''
  }

  let result = String(value)

  for (let i = 0; i < 10; i++) {
    result = result.replaceAll(PERSIAN_DIGITS[i], String(i))
    result = result.replaceAll(ARABIC_DIGITS[i], String(i))
  }

  return result
}

export function normalizePhoneNumber(value) {
  const english = toEnglishDigits(value).trim()
  const hasPlus = english.startsWith('+')
  const digits = english.replace(/\D/g, '')

  return hasPlus ? `+${digits}` : digits
}
